import type { BaInpaintTaskStatus } from './ai'

/**
 * 后端接口返回分页查询列表数据格式
 */
export interface List<T> {
  /**
   * 当此返回的数据
   */
  data?: Array<T>
  /**
   * 下一次分页查询的ID
   */
  next?: string
}

/**
 * 后端接口返回图片语义分割和生成图片任务状态数据结构
 */
export interface AITask<T> {
  /**
   * 任务ID
   */
  taskId: string | null
  /**
   * 任务状态
   */
  status: BaInpaintTaskStatus | null
  /**
   * 语义分割返回数据
   */
  data: T | null
  /**
   * 生成图片返回数据
   */
  images: T | null
  /**
   * 更新状态时返回的图片ID
   */
  imageId: string
  /**
   * 更新状态时返回的图片URL
   */
  imageUrl: string
}

export enum BonjourStatus {
  OK = 1,
  STOP = 2,
  UNINSTALLED = 3
}

export enum GA4Event {
  USER_LOGIN = 'login',
  USER_REGISTER = 'sign_up',
  USER_INVITATION_CODE = 'user_invitation_code',
  USER_PHONE_BIND = 'user_phone_bind',
  USER_COPY_INVITATION_CODE = 'share',
  USER_COPY_LINK = 'share',
  USER_SHARE = 'share',
  USER_BEGIN_SUBSCRIPTION = 'begin_subscription',
  VIEW_SUBSCRIPTION_LIST = 'view_subscription_list',
  USER_SUBSCRIBE_SUCCESS = 'subscription',
  USER_SUBSCRIBE_CANCEL = 'subscription_cancel',
  USER_SUBSCRIBE_EDIT = 'subscription_edit',
  IMAGE_GENERATE = 'image_generate',
  LOOK_PAGE_VIEW = 'page_view',
  SAVE_HD = 'save_hd',
  ENHANCEMENT = 'enhancement',
  IMAGE_2_TEXT = 'image_2_text',
  VISION_SEARCH = 'vision_search',
  VISION_SEARCH_DOWNLOAD = 'vision_search_download',
  DOWNLOAD_APP = 'download_app',
  BEGIN_USER_GUIDE_TASK = 'begin_user_guide_task',
  USER_ACTIVATION = 'user_activation'
}
